export enum PaginatorPosition {
  CENTER = 'center',
  LEFT = 'left',
  RIGHT = 'right',
}
